import { CardFunding } from 'shared/types/graphql';
/**
 * Convert string of 'credit', 'debit', 'prepaid', 'unknown' to CardFunding.Credit, CardFunding.Debit, CardFunding.Prepaid, CardFunding.Unknown
 * @param fundingType - string of 'credit', 'debit', 'prepaid', 'unknown' || undefined
 * @returns CardFunding.Credit, CardFunding.Debit, CardFunding.Prepaid, CardFunding.Unknown || undefined
 * @example
 * cardFundingTypeConverter('credit') => CardFunding.Credit
 */

export const cardFundingTypeConverter = (fundingType: string | undefined): CardFunding | undefined => {
  switch (fundingType) {
    case 'credit':
      return CardFunding.Credit;
    case 'debit':
      return CardFunding.Debit;
    case 'prepaid':
      return CardFunding.Prepaid;
    case 'unknown':
      return CardFunding.Unknown;
    default:
      return undefined;
  }
};
